import {GenericService} from '@/shared/xhttp';
import {Fournisseur} from '@/models';

export class FournisseurService extends GenericService<Fournisseur> {
}